import e from "../managers/braze-instance.js";
import r from "../../shared-lib/braze-shared-lib.js";
import O, { STORAGE_KEYS as i } from "../managers/storage-manager.js";
export function enableSDK() {
  new O.ee(null, !0).remove(i.re);
  const a = r.zt.Ft;
  new r.xt(a, r.j).oe(a.Jt.se, a.ie),
    r.j.info("enableSDK was called"),
    e.destroy(!1),
    e.ne(!1);
}
